import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import Chart from "pro-features/components/Chart/src/Chart";
import { TrafficShare } from "app/components/React/Table/cells";
import { i18nFilter } from "app/filters/i18nFilter";
import { StyledCoreWebsiteCell } from "app/pages/segments/analysis/StyledComponents";
import { dateToUTC } from "app/pages/website-analysis/incoming-traffic/chartConfig";
import { getOverTimeChartConfigSingle } from "app/pages/website-analysis/incoming-traffic/commonOverTime";
import {
    CloseIconButton,
    OutgoingTrafficOverTimeIndex,
    ToggleIconButton,
    TrafficOverTime,
    TrafficOverTimeChart,
    TrafficOverTimeChartTitle,
    TrafficOverTimeLeft,
    TrafficOverTimeShareWrap,
    TrafficOverTimeTitle,
    TrafficOverTimeWebSiteWrap,
} from "app/pages/website-analysis/incoming-traffic/StyledComponents";
import TrafficOverTimeChartNoData from "app/pages/website-analysis/TrafficOverTimeChartNoData";
import type { FunctionComponent } from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import DurationService from "app/services/DurationService";
import { allTrackers } from "app/services/track/track";

export const OutgoingTrafficEnriched: FunctionComponent<any> = (props) => {
    const i18n = i18nFilter();
    const { pageSize, pageNumber, row, enableQualificationSideBar, handleOpenQualificationSideBar } = props;
    const { TotalSharePerMonth, Domain, Share, index, Favicon } = row;
    const params = proNavigator.getParams();
    const durationRaw = DurationService.getDurationData(params.duration).raw;
    const { from, to } = durationRaw;
    const duration = DurationService.getDiffSymbol(from, to);
    const showTrafficOverTimeChartNoData = ["28d", "1m"].includes(duration);
    const clickOutsideXButton = (e) => {
        allTrackers.trackEvent("Open", "Click", "Traffic Over Time/Collapsed");
        document.body.click();
    };
    const data = TotalSharePerMonth.map((item) => [dateToUTC(item.Key), item.Value]);
    const graphData = [{ data }];
    return (
        <>
            <TrafficOverTime>
                <TrafficOverTimeLeft>
                    <div onClick={clickOutsideXButton}>
                        <ToggleIconButton
                            iconName="chev-down"
                            type="flat"
                        />
                    </div>
                    <OutgoingTrafficOverTimeIndex>{pageNumber * pageSize + index + 1}</OutgoingTrafficOverTimeIndex>
                    <TrafficOverTimeWebSiteWrap>
                        <StyledCoreWebsiteCell
                            icon={Favicon}
                            domain={Domain}
                            externalLink={`http://${Domain}`}
                            trackExternalLink={() =>
                                allTrackers.trackEvent("external link", "click", `Conversion Category Overview`)
                            }
                            handleOpenQualificationSideBar={
                                enableQualificationSideBar
                                    ? () => {
                                          document.body.click();
                                          handleOpenQualificationSideBar({ Domain, Favicon });
                                      }
                                    : undefined
                            }
                        />
                    </TrafficOverTimeWebSiteWrap>
                    <TrafficOverTimeShareWrap>
                        <TrafficOverTimeTitle>
                            {i18n("analysis.source.referrals.table.columns.share.title")}
                        </TrafficOverTimeTitle>
                        <TrafficShare
                            {...props.row}
                            value={Share}
                            row={props.row}
                        />
                    </TrafficOverTimeShareWrap>
                </TrafficOverTimeLeft>
                <CloseIconButton
                    type="flat"
                    onClick={clickOutsideXButton}
                    iconName="clear"
                    placement="left"
                />
            </TrafficOverTime>
            {!showTrafficOverTimeChartNoData ? (
                <TrafficOverTimeChart>
                    <TrafficOverTimeChartTitle>
                        <BoxTitle tooltip={i18n("outgoingtraffic.overtime.chart.title.tooltip")}>
                            {i18n("outgoingtraffic.overtime.chart.title")}
                        </BoxTitle>
                    </TrafficOverTimeChartTitle>
                    <Chart
                        type="area"
                        config={getOverTimeChartConfigSingle("line")}
                        data={graphData}
                        domProps={{ style: { height: "250px" } }}
                    />
                </TrafficOverTimeChart>
            ) : (
                <TrafficOverTimeChartNoData />
            )}
        </>
    );
};
